import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import * as moment from 'moment';
import { CalendarValue, IDatePickerConfig } from 'ng2-date-picker';
import { DateRangeCubeJs } from 'src/app/enums/cubejs/date-range';
import { I18dateRange } from 'src/app/enums/i18-date-range.enum';
import { CalculationFunction } from 'src/app/enums/stations/calculation-function';
import { BaseFromFilterEvent } from 'src/app/models/filterNgraph/BaseFromFilterEvent';
import { SelectConfig } from '../select/config/SelectConfig';

@Component({
    selector: 'app-date-range-filter',
    templateUrl: './date-range-filter.component.html',
    styleUrls: ['./date-range-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateRangeFilterComponent implements OnInit {

  @Output() filtersUpdate: EventEmitter<BaseFromFilterEvent> = new EventEmitter();

  userWantsCustomDateRange: boolean = false;

  endDateFilter: moment.Moment;
  startDateFilter: moment.Moment;
  isValidDateRange: boolean = true;

  language: 'fr' | 'en' = 'fr';
  datePickerConfig: IDatePickerConfig = {
    disableKeypress: false,
    format: 'DD/MM/YYYY',
    monthFormat: 'MMMM, YYYY',
    firstDayOfWeek: 'mo',
    showTwentyFourHours: true,
    showSeconds: false,
    showGoToCurrent: true,
    showNearMonthDays: false,
    hideOnOutsideClick: true,
    enableMonthSelector: true,
    allowMultiSelect: false
  };
  endDatePickerConfig = this.datePickerConfig;
  startDatePickerConfig = this.datePickerConfig;

  filtersState: BaseFromFilterEvent = {
    paramStartDate: '',
    paramEndDate: ''
  }

  selectConfig: SelectConfig = {
    label: 'timeGroup.for',
    displayAxis: 'y',
    hasNullOption: false,
    initialOptionValue: DateRangeCubeJs.TODAY,
    options: [
      {key:I18dateRange.CUSTOM, value: DateRangeCubeJs.CUSTOM},
      {key:I18dateRange.TODAY, value: DateRangeCubeJs.TODAY},
      {key:I18dateRange.YESTERDAY, value: DateRangeCubeJs.YESTERDAY},
      {key:I18dateRange.LAST_7_DAYS, value: DateRangeCubeJs.LAST_7_DAYS},
      {key:I18dateRange.LAST_30_DAYS, value: DateRangeCubeJs.LAST_30_DAYS},
      {key:I18dateRange.THIS_WEEK, value: DateRangeCubeJs.THIS_WEEK},
      {key:I18dateRange.THIS_MONTH, value: DateRangeCubeJs.THIS_MONTH},
      {key:I18dateRange.THIS_QUARTER, value: DateRangeCubeJs.THIS_QUARTER},
      {key:I18dateRange.THIS_YEAR, value: DateRangeCubeJs.THIS_YEAR},
      {key:I18dateRange.LAST_WEEK, value: DateRangeCubeJs.LAST_WEEK},      
      {key:I18dateRange.LAST_MONTH, value: DateRangeCubeJs.LAST_MONTH},
      {key:I18dateRange.LAST_QUARTER, value: DateRangeCubeJs.LAST_QUARTER},
      {key:I18dateRange.LAST_YEAR, value: DateRangeCubeJs.LAST_YEAR}
    ],
  }

  constructor() { }

  ngOnInit(): void {
    this.setDatePickersValues(this.selectConfig.initialOptionValue);
  }

  onDateRangeChange(dateRange: DateRangeCubeJs){
    this.toggleDatePickers(dateRange);
    this.setDatePickersValues(dateRange);
  }

  toggleDatePickers(dateRange: DateRangeCubeJs){
    if (dateRange === DateRangeCubeJs.CUSTOM) {
      this.userWantsCustomDateRange = true;
    } else {
      this.userWantsCustomDateRange = false;
    }
  }

  setDatePickersValues(dateRange: DateRangeCubeJs){
    switch(dateRange){
      case DateRangeCubeJs.CUSTOM :
        break;
      case DateRangeCubeJs.TODAY :
        this.endDateFilter = moment.default().endOf('day').utc();
        this.startDateFilter = moment.default().startOf('day').utc();
        break;
      case DateRangeCubeJs.YESTERDAY :
        this.endDateFilter = moment.default().subtract(1, 'days').endOf('day').utc();
        this.startDateFilter = moment.default().subtract(1, 'days').startOf('day').utc();
        break;
      case DateRangeCubeJs.LAST_7_DAYS :
        this.endDateFilter = moment.default().subtract(1, 'days').endOf('day').utc();
        this.startDateFilter = moment.default().subtract(7, 'days').startOf('day').utc();
        break;
      case DateRangeCubeJs.LAST_30_DAYS :
        this.endDateFilter = moment.default().subtract(1, 'days').endOf('day').utc();
        this.startDateFilter = moment.default().subtract(30, 'days').startOf('day').utc();
        break;
      case DateRangeCubeJs.THIS_WEEK :
        this.endDateFilter = moment.default().endOf('week').utc();
        this.startDateFilter = moment.default().startOf('week').utc();
        break;
      case DateRangeCubeJs.THIS_MONTH :
        this.endDateFilter = moment.default().endOf('month').utc();
        this.startDateFilter = moment.default().startOf('month').utc();
        break;
      case DateRangeCubeJs.THIS_QUARTER :
        this.endDateFilter = moment.default().endOf('quarter').utc();
        this.startDateFilter = moment.default().startOf('quarter').utc();
        break;
      case DateRangeCubeJs.THIS_YEAR :
        this.endDateFilter = moment.default().endOf('year').utc();
        this.startDateFilter = moment.default().startOf('year').utc();
        break;
      case DateRangeCubeJs.LAST_WEEK :
        this.endDateFilter = moment.default().subtract(1, 'week').endOf('week').utc();
        this.startDateFilter = moment.default().subtract(1, 'week').startOf('week').utc();
        break;
      case DateRangeCubeJs.LAST_MONTH :
        this.endDateFilter = moment.default().subtract(1, 'month').endOf('month').utc();
        this.startDateFilter = moment.default().subtract(1, 'month').startOf('month').utc();
        break;
      case DateRangeCubeJs.LAST_QUARTER :
        this.endDateFilter = moment.default().subtract(1, 'quarter').endOf('quarter').utc();
        this.startDateFilter = moment.default().subtract(1, 'quarter').startOf('quarter').utc();
        break;
      case DateRangeCubeJs.LAST_YEAR :
        this.endDateFilter = moment.default().subtract(1, 'year').endOf('year').utc();
        this.startDateFilter = moment.default().subtract(1, 'year').startOf('year').utc();
        break;
      default:
        this.endDateFilter = moment.default().endOf('day').utc();
        this.startDateFilter = moment.default().startOf('day').utc();
    }
    this.filtersState.stepRange = this.endDateFilter.diff(this.startDateFilter, 'days') + 1;
    this.transfertFilterState(dateRange);
  }

  onChangeCustomDate(calendarValue: CalendarValue): void {
    if (calendarValue) {
      this.isValidDateRange = this.startDateFilter <= this.endDateFilter;
      if (this.isValidDateRange) {
        this.filtersState.stepRange = this.endDateFilter.diff(this.startDateFilter, 'days');
        this.transfertFilterState();
      }
    }
  }

  transfertFilterState(dateRange?: DateRangeCubeJs){
    this.filtersState.dateRange = dateRange;
    this.filtersState.paramStartDate = this.startDateFilter.utc().format();
    this.filtersState.paramEndDate = this.endDateFilter.utc().format();
    this.filtersUpdate.emit(this.filtersState);
  }

}
